import usedeletedata from '../../Hooks/useDeleteData';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdata, useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateDatawithimage, UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_CompanyProfile_Type,
  Get_All_CompanyProfile_Type,
  Get_Error,
  Update_Specififc_CompanyProfile_Type,
} from '../Types';

export const InsertCompanyProfileData = (formdata) => async (dispatch) => {
  try {
    const res = await useinsertdata(`/api/v1/CompanyProfile`, formdata);

    dispatch({
      type: Add_CompanyProfile_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_All_Company_Profile = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/CompanyProfile`);

    dispatch({
      type: Get_All_CompanyProfile_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const UpdateCompanyProfileData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateDatawithimage(`/api/v1/CompanyProfile/${id}`, body);

    dispatch({
      type: Update_Specififc_CompanyProfile_Type, // تأكد إنه مكتوب صح
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response, // استخدم response مش res
    });
  }
};
